import { CoreAgentConversationTitlesName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultAgentConversationTitlesState } from './state';

export type UpdateAgentConversationTitleRequest = {
	id: number;
	status: 'pending' | 'gaveUp';
};

export const updateCoreAgentConversationTitleSyncSlice = createUpdateSyncSlice({
	name: CoreAgentConversationTitlesName,
	state: defaultAgentConversationTitlesState,
	transform: ({ id, status }: UpdateAgentConversationTitleRequest, state = {}) => {
		const current = state[ id ]?.status;
		if (current === 'ready' || (status === 'gaveUp' && current !== 'pending')) {
			return state;
		}

		state[ id ] = {
			status,
			title: null
		};

		return state;
	}
});
